import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { EmailList } from '../models/email-list';

@Injectable()
export class EmailListService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  // fetch from the server email lists of the current user
  getEmailLists(): Observable<EmailList[]> {
    const get_url = `${environment.surveyApiHost}/api/v1/email_lists/`;

    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map((response: any) => {
        const json = response;
        const email_lists: EmailList[] = json.map(EmailList.fromJSON);
        return email_lists;
      })
      .catch(this.handleError);
  }

  getEmails(email_list: EmailList): Observable<Array<any>> {
    const get_url = `${environment.surveyApiHost}/api/v1/email_lists/${email_list.id}/emails/`;
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map((response: any) => {
        const json = response;
        return json;
      })
      .catch(this.handleError);
  }

  addEmailList(email_list: EmailList): Observable<any> {
    const post_url = `${environment.surveyApiHost}/api/v1/email_lists/`;
    console.log('POST ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .post(post_url, email_list.toJSON(), { headers: headers })
      .map(this.processPostPutResponse)
      .catch(this.handleError);
  }

  updateEmailList(email_list: EmailList): Observable<any> {
    const put_url = `${environment.surveyApiHost}/api/v1/email_lists/${email_list.id}/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    console.log('page: ', email_list.toJSON());
    return (
      this.http
        .put(put_url, email_list.toJSON(), { headers: headers })
        //     .map(this.processPostPutResponse)
        .catch(this.handleError)
    );
  }

  deleteEmailList(email_list: EmailList): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/email_lists/${email_list.id}/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .delete(delete_url, { headers: headers })
      .catch(this.handleError);
  }

  private processPostPutResponse(res: any): EmailList {
    console.log('processPostResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const email_list: EmailList = Object.create(EmailList.prototype);
    const obj = Object.assign(email_list, body, {});
    return obj || {};
  }

  private handleError(error: any | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
